import { useCallback, useEffect, useRef, useState } from 'react';

function getInitials(user, profile) {
    const firstName = (profile?.basicDetails?.firstName || user?.firstName || '').trim();
    const lastName = (profile?.basicDetails?.lastName || user?.lastName || '').trim();
    if (firstName && lastName) return `${firstName[0]}${lastName[0]}`.toUpperCase();
    if (firstName) return firstName[0].toUpperCase();
    return (user?.email?.[0] || '?').toUpperCase();
}

const UserMenu = ({ user, profile, links, variant = 'site' }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);

    const close = useCallback(() => setOpen(false), []);
    const toggle = useCallback((e) => {
        e.stopPropagation();
        setOpen((prev) => !prev);
    }, []);

    useEffect(() => {
        if (!open) return undefined;
        const onDocClick = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                close();
            }
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, [open, close]);

    const menuItems = links && links.map((item, index) => (
        <div key={`${item.name}-${index}`}>
            <button
                type="button"
                role="menuitem"
                className={item.name === 'Sign out' ? 'menu-signout' : undefined}
                onClick={() => {
                    close();
                    item.action?.();
                }}
            >
                {item.name}
            </button>
            {item.divider && <div className="divider" aria-hidden="true" />}
        </div>
    ));

    if (variant === 'app') {
        const initials = getInitials(user, profile);

        return (
            <div
                ref={rootRef}
                className={`app-header-account${open ? ' open' : ''}`}
            >
                <button
                    type="button"
                    className="app-header-caret"
                    aria-expanded={open}
                    aria-haspopup="menu"
                    aria-label="Account menu"
                    onClick={toggle}
                >
                    ▾
                </button>
                <button
                    type="button"
                    className="app-avatar"
                    aria-expanded={open}
                    aria-haspopup="menu"
                    aria-label="Account menu"
                    onClick={toggle}
                >
                    {initials}
                </button>
                <div className="app-header-account-menu" role="menu" onClick={(e) => e.stopPropagation()}>
                    <div className="menu-header">Account</div>
                    {user?.email && (
                        <div className="menu-header" style={{ textTransform: 'none', letterSpacing: 0, fontWeight: 500 }}>
                            {user.email}
                        </div>
                    )}
                    {menuItems}
                </div>
            </div>
        );
    }

    return (
        <div
            ref={rootRef}
            className={`site-nav-account${open ? ' open' : ''}`}
        >
            <button
                type="button"
                className="site-nav-link"
                aria-expanded={open}
                aria-haspopup="menu"
                onClick={toggle}
            >
                Account ▾
            </button>
            <div className="site-nav-account-menu" role="menu" onClick={(e) => e.stopPropagation()}>
                <div className="menu-header">Account</div>
                {user?.email && (
                    <div className="menu-header" style={{ textTransform: 'none', letterSpacing: 0, fontWeight: 500 }}>
                        {user.email}
                    </div>
                )}
                {menuItems}
            </div>
        </div>
    );
};

export default UserMenu;
